import React from 'react';
import { TableColumn } from "tea-component";
import EllipsisTextBubble from "@gp/components/EllipsisTextBubble";
import { getRoundIntegerNum } from '@gp/utils/common';

const getColumns = (colList: string[], type: HeadcountsDataType, isFixedFirstColumn = true) => {
  const opt: 	TableColumn<any>[] = [
    {
      key: "metric",
      header: type === '1' ? 'Function' : 'Projects',
      width: 200,
      align: 'left',
      fixed: isFixedFirstColumn ? 'left' : undefined,
      render: (cvm: any) => {
        return (
          <EllipsisTextBubble
            text={cvm?.metric || '-'}
          />
        );
      },
    },
  ];
  if (Array.isArray(colList) && colList?.length) {
    for (let i = 0; i < colList?.length; i ++) {
      const t: string = colList?.[i];
      opt.push({
        key: t,
        header: t,
        width: 130,
        align: 'right',
        render: (cvm: any) => {
          return getRoundIntegerNum(cvm?.[t]);
        },
      });
      // 如果只有一列时间，加一列空的占位，使得数据居中一些
      if (colList?.length === 1) {
        opt.push({
          key: 'empty_col',
          header: null,
          width: 200,
          align: 'right',
          render: (cvm: any) => {
            return null;
          },
        });
      }
    }
  }

  return opt;
}

export {
  getColumns,
}
